// extracted by mini-css-extract-plugin
module.exports = {"container":"filterOption_container_117eP","text":"filterOption_text_1gpNf","remove":"filterOption_remove_2DLxV"};